/**
 * Manage language loading
 * @type {{MAX_AGE: number, _current: null, _getAjaxUrl: app.languages._getAjaxUrl, _data: {}, _restore: app.languages._restore, _persist: app.languages._persist, _update: app.languages._update, load: app.languages.load, current: app.languages.current}}
 */
app.languages = {
  /** The maximal number of seconds that an already downloaded language pack will be considered up to date. Afterwards will be updated in the background */
  MAX_AGE: 10,
  _current: undefined,
  _hashCode: function hashCode(str) {
    //for testing purpose, avoid caching translation locally.
    if (cfnGlobals.isDev) return new Date().getTime();
    var hash = 0,
      i,
      chr,
      len;
    if (!str || str.length == 0) {
      return hash;
    }
    for (i = 0, len = str.length; i < len; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },
  _getAjaxUrl: function(locale) {
    //version will be the absolute value of the hash value computed from the release string
    let version = Math.abs(this._hashCode(app.credentials.release));
    return '/365FarmNet/rest/localize/' + locale + '?v=' + version;
  },
  _data: {},
  _restore: function() {
    try {
      var cacheStr = localStorage.getItem('cache_language');
      if (cacheStr) {
        var cache = JSON.parse(cacheStr);
        if (cache) {
          app.languages._data[cache.locale] = cache;
          app.languages._current = cache.locale;
        }
      }
    } catch (e) {
      console.warn('cache miss for language cache', e);
    }
  },
  _persist: function(cacheData) {
    try {
      localStorage.setItem('cache_language', JSON.stringify(cacheData));
    } catch (e) {
      console.warn('Could not cache language: ' + e);
    }
  },
  _update: function(locale, data) {
    app.languages._data[locale] = {
      locale: locale,
      since: Date.now(),
      data: data
    };
    app.languages._persist(app.languages._data[locale]);
    app.translations = data;
    if (window.enums && window.i18n) window.enums.load(window.i18n);
  },
  /**
   * Clear all cached data.
   */
  clearCache: function() {
    app.languages._data = {};
    app.languages._current = undefined;
  },
  /**
   * jQuery compatible version for backwards compatibility
   * @param locale the locale to be loaded
   * @returns {*} jquery Deferred the language package
   */
  load: locale => {
    const deferred = $.Deferred();

    app.languages.fetchLoad(locale).then(data => {
      deferred.resolve(data);
    });

    return deferred;
  },
  /**
   * Loads a language package from memory, localStorage or the backend. If the package is marked as too old,
   * the older version will be returned immediately, but a newer version will be gather in the background, i.e. the page rendering
   * won't be stopped.
   * @param locale the locale to be loaded
   * @returns {*} promise the language package
   */
  fetchLoad: locale => {
    return new Promise(resolve => {
      const lang = app.languages._data[locale];
      // check `lang.data` for firefox's white page relogin issue
      const fetchLocalTranslation = () => {
        app.languages.fetch(locale).then(data => {
          app.languages._current = locale;
          app.languages._update(locale, data);
          resolve(data);
        });
      };

      if (lang && lang.data !== undefined && lang.data !== null) {
        if ((Date.now() - lang.since) / 1000 > app.languages.MAX_AGE) {
          // load fresh translation when outdated local translation

          fetchLocalTranslation();
        }
        app.languages._current = locale;
        app.languages._update(locale, lang.data); // test, must be properly implemented
        resolve(lang.data);
      } else {
        fetchLocalTranslation();
      }
    });
  },
  fetch: locale => {
    return fetch(app.languages._getAjaxUrl(locale), {
      credentials: 'same-origin'
    })
      .then(response => {
        return response.json();
      })
      .catch(ex => console.error('Could not load language file'));
  },
  /**
   * @returns {string|null} the last selected language package or null if nothing was found.
   */
  current: function() {
    return app.languages._current;
  }
};
app.languages._restore();
